import 'swiper/css/effect-fade';

document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;

  AOS.init({ once: true });

  // Scroll to top
  var scrollTopId = document.getElementById('scrollTop');
  if (scrollTopId) {
    scrollTopId.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      scroll(e.target.hash, {
        duration: 400,
      });
    });

    window.addEventListener(
      'scroll',
      () => {
        var scrollPosition = window.scrollY || window.pageYOffSet;
        if (scrollPosition > scrollTopId.dataset.showOffset) {
          scrollTopId.classList.add('active');
        } else {
          scrollTopId.classList.remove('active');
        }
      },
      false
    );
  }

  // toggle password
  document.querySelectorAll('[data-toggle="password"]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      const target = el.dataset.target;
      document.querySelector(target).focus();
      const icon = el.querySelector('.sa-icon');

      if (document.querySelector(target).getAttribute('type') == 'password') {
        document.querySelector(target).setAttribute('type', 'text');
        icon.classList.remove('sa-icon-eye');
        icon.classList.add('sa-icon-eye-off');
      } else {
        document.querySelector(target).setAttribute('type', 'password');
        icon.classList.remove('sa-icon-eye-off');
        icon.classList.add('sa-icon-eye');
      }
    });
  });

  var docsFilterCountNum = 0;

  //documents filter
  var filterTogglerId = document.getElementById('docFilterToggler');
  var filterCloseId = document.getElementById('docFilterClose');
  var filterBackdrop = document.querySelector('.filter-backdrop');

  const docsFilterApply = document.getElementById('docs-filter-apply');

  if (filterTogglerId && filterCloseId && filterBackdrop) {
    filterTogglerId.addEventListener('click', function (e) {
      body.classList.toggle('page-filter');
    });
    filterBackdrop.addEventListener('click', function (e) {
      body.classList.remove('page-filter');
    });
    filterCloseId.addEventListener('click', function (e) {
      if (docsFilterCountNum > 0) {
        docsFilterApply.click();
      }
      body.classList.remove('page-filter');
    });
  }

  const docsFilterList = document.getElementById('filter-documents');

  if (docsFilterList) {
    docsFilterList.addEventListener('click', function (event) {
      if (!event.target.matches('.form-check-input')) return;
      docsFilterCountNum = docsFilterList.querySelectorAll('.form-check-input:checked').length;
      docsFilterCountUpdate(docsFilterCountNum);
    });
  }

  let docsFilterResetBtns = document.querySelectorAll('.js-docs-filter-reset');
  if (docsFilterResetBtns) {
    docsFilterResetBtns.forEach((btn) => {
      if (btn.classList.contains('dont-reload')) {
        btn.addEventListener('click', (e) => {
          docsFilterReset();
        });
      } else {
        btn.addEventListener('click', (e) => {
          docsFilterReset();
          docsFilterApply.click();
        });
      }
    });
  }

  let docsFilterCounts = document.querySelectorAll('.js-docs-filter-count');
  function docsFilterCountUpdate(count) {
    if (docsFilterCounts) {
      docsFilterCounts.forEach((el) => {
        el.textContent = `(${count})`;
      });
    }
  }
  function docsFilterReset() {
    docsFilterList.querySelectorAll('.form-check-input').forEach((checkbox) => {
      checkbox.checked = false;
      docsFilterCountNum = 0;
      docsFilterCountUpdate(docsFilterCountNum);
    });
  }

  //sideover people
  var sideoverPeopleId = document.getElementById('sideoverPeople');

  document.querySelectorAll('[data-toggle="sideover"]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var triggerEl = document.querySelector(
        '#tabPeople > [href="' + el.getAttribute('href') + '"]'
      );
      if (triggerEl && sideoverPeopleId) {
        triggerEl.click();
        body.classList.toggle('sideover-open');
        sideoverPeopleId.setAttribute('aria-expanded', 'true');
        sideoverPeopleId.addEventListener('click', sideoverBackdrop, false);
      }
    });
  });

  var sideoverClose = document.querySelector('[data-dismiss="sideover"]');
  if (sideoverClose) {
    sideoverClose.addEventListener('click', function (e) {
      var active = document.querySelector('.sideover[aria-expanded="true"]');
      if (active) {
        body.classList.remove('sideover-open');
        active.setAttribute('aria-expanded', 'false');
      }
    });
  }
  var sideoverBackdrop = function (e) {
    if (!e.target.closest('.sideover-dialog')) {
      body.classList.remove('sideover-open');
      e.target.setAttribute('aria-expanded', 'false');
      e.target.removeEventListener('click', sideoverBackdrop, false);
    }
  };

  //load event
  window.addEventListener('load', function (e) {
    const body = document.body;
    body.classList.remove('page-preload');
    body.classList.add('page-loaded');

    if (window.location.hash) {
      var hash = window.location.hash.substring(1);

      scroll('[data-anchor="#' + hash + '"  i]', {
        duration: 200,
      });
    }

    document.querySelectorAll('.anchor').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var offset;
        if (!el.hasAttribute('data-anchor-offset')) {
          offset = -80;
        } else {
          offset = el.dataset.anchorOffset;
        }

        scroll('[data-anchor="' + e.target.hash + '" i]', {
          duration: 200,
          offset: parseInt(offset),
        });
      });
    });
  });
});

function scroll(target, options) {
  var start = window.pageYOffset,
    opt = {
      duration: options.duration,
      offset: options.offset || 0,
      callback: options.callback,
      easing: options.easing || easeInOutQuad,
    },
    distance =
      typeof target === 'string'
        ? opt.offset + (document.querySelector(target)?.getBoundingClientRect().top || 0)
        : target,
    duration = typeof opt.duration === 'function' ? opt.duration(distance) : opt.duration,
    timeStart,
    timeElapsed;

  requestAnimationFrame(function (time) {
    timeStart = time;
    loop(time);
  });

  function loop(time) {
    timeElapsed = time - timeStart;

    window.scrollTo(0, opt.easing(timeElapsed, start, distance, duration));

    if (timeElapsed < duration) requestAnimationFrame(loop);
    else end();
  }

  function end() {
    window.scrollTo(0, start + distance);

    if (typeof opt.callback === 'function') opt.callback();
  }

  // Robert Penner's easeInOutQuad - http://robertpenner.com/easing/
  function easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  }
}
